import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { FaBars, FaSignOutAlt, FaBell, FaUserCircle } from "react-icons/fa";
import Sidebar from "./Sidebar";

const HeaderWrapper = styled.header`
  height: 60px;

  background: linear-gradient(to left, #001f54, #001a47);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.57);
  position: sticky;
  top: 0;
  z-index: 100;
`;

const Left = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const Right = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

const Button = styled.button`
  border: none;
  background: none;
  cursor: pointer;
  font-size: 20px;
  color: #fff;
`;

const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  svg{
  color: fff;
  }
`;

const UserDetails = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 14px;
  line-height: 1.2;
`;

const UserName = styled.span`
  font-weight: bold;
  font-size: 16px;
  color:rgb(255, 255, 255);
`;

const UserPerfil = styled.span`
  color: #888;
`;

const Avatar = styled.img`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  background: #fff;
`;

export default function Header() {
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [usuario, setUsuario] = useState({ nome: "Usuário", perfil: "", foto: "" });

  useEffect(() => {
    const storedUser = JSON.parse(localStorage.getItem("usuario"));
    if (storedUser) setUsuario(storedUser);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    window.location.href = "/";
  };

  return (
    <>
      <HeaderWrapper>
        <Left>
          <Button onClick={() => setSidebarExpanded(!sidebarExpanded)}>
            <FaBars />
          </Button>

          <UserInfo>
            {/* Avatar ou ícone */}
            {usuario.foto ? (
              <Avatar src={usuario.foto} alt="Foto de perfil" />
            ) : (
              <FaUserCircle size={40} color="#fff"/>
            )}

            <UserDetails>
              <UserName>{usuario.nome}</UserName>
              <UserPerfil>{usuario.perfil}</UserPerfil>
            </UserDetails>
          </UserInfo>
        </Left>

        <Right>
          <Button><FaBell /></Button>
          <Button onClick={handleLogout}><FaSignOutAlt /></Button>
        </Right>
      </HeaderWrapper>

      <Sidebar expanded={sidebarExpanded} onClose={() => setSidebarExpanded(false)} />
    </>
  );
}